<template>
  <div class="forgot-password">
    <vue-headful title="Forgot Password - Alabama.travel" description="Reset your password and begin to plan your next trip to beautiful Alabama." url="https://alabama.travel/forgot-password"/>
    <div class="container">
      <div class="d-flex flex-row justify-content-center">
        <div>
          <div class="forgot-your-password">Forgot Your Password?</div>
          <div class="we-all-forget">We all forget our password sometimes. Enter your email address below so we can help you reset your password.</div>
          <input @click="showEmailHelp" id="email" type="text" v-model="email" placeholder="Email Address" class="input-container email-address" :aria-invalid="invalidEmail" />
          <div class="help-error" aria-live="polite">
            <span :style="{display: emailHelp ? 'inline-block' : 'none'}">Your email address is required.</span>
            <span>{{this.emailMessage}}</span>
          </div>
          <button @click="resetPassword" :disabled="disabledLogin" class="reset-btn"><div class="reset-text">Reset Password</div></button>
          <div class="sign-in-with-password"><router-link to="/sign-in" class="sign-in">Sign-in with Password</router-link></div>
          <div class="not-a-member">Not a member? <router-link to="/signup" class="register-now">Register now!</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  name: 'forgot password',
  data() {
    return {
      email: '',
      disabledLogin: false,
      emailMessage: '',
      emailHelp: false,
      invalidEmail: false,
    };
  },
  methods: {
    async resetPassword() {
      try {
        this.validateInput();
        const userEmail = this.email;
        await Auth.forgotPassword(
          this.email,
        );
        this.$router.push({
          name: 'forgotPasswordConfirmation',
          params: { userEmail },
        });
      } catch (err) {
        if (err.message === 'Username/client id combination not found.') {
          this.emailMessage = 'Invalid email address.';
          this.invalidEmail = true;
          this.disabledLogin = false;
        } else if (err.message === 'Username cannot be empty') {
          this.emailMessage = 'Your email address is required.';
          this.invalidEmail = true;
          this.disabledLogin = false;
        } else {
          this.emailMessage = err.message;
          this.invalidEmail = true;
          this.disabledLogin = false;
        }
      }
    },
    validateInput() {
      this.emailMessage = '';
      this.emailHelp = false;
      this.disabledLogin = true;
      if (this.email === '') {
        this.emailMessage = 'Your email address is required.';
        this.disabledLogin = false;
      } else if (this.validFormat(this.email) === false) {
        this.email = '';
        this.emailMessage = 'Double check your email address.';
        this.disabledLogin = false;
      }
    },
    validFormat(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(email);
      return result;
    },
    showEmailHelp() {
      this.emailMessage = '';
      this.emailHelp = true;
    },
  },
};
</script>

<style scoped>
  .forgot-password {
    margin-top: 40px;
  }
  .forgot-your-password {
    width: 245px;
    height: 60px;
    margin: 0 auto;
    font-family: IdealSans-Medium;
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.83px;
    text-align: center;
    color: #173945;
  }
  .we-all-forget {
    width: 300px;
    height: 48px;
    margin: 21px auto 28px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.39px;
    text-align: center;
    color: #173945;
  }
  .input-container {
    width: 300px;
    height: 50px;
    padding: 18px 12px;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #fff;
    color: black;
  }
  .input-container::placeholder {
    color: black;
    opacity: 1;
  }
  .email-address {
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    color: #000;
  }
  .help-error {
    width: 300px;
    height: 12px;
    margin: 0 0 100px 25px;
    font-family: IdealSans-Medium;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.33px;
    text-align: left;
    color: #000;
  }
  .reset-btn {
    width: 300px;
    height: 61px;
    padding: 18px 0 ;
    border-radius: 8px;
    border: solid 1px #979797;
    background-color: #173945;
    cursor: pointer;
  }
   .reset-btn:focus {
    outline: 2.75px dotted !important;
    outline-color: #4c8ea0 !important;
    outline-offset: 3px !important;
  }
  .reset-btn:hover {
    box-shadow: 0px 0px 3px #173945;
  }
  .reset-text {
    width: 160px;
    height: 18px;
    font-family: IdealSans-Medium;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.5px;
    text-align: center;
    color: #f7f6f1;
    margin: 0 auto;
  }
  .sign-in:visited {
    color: #a5b1b6;
  }
  .register-now:visited {
    color: #173945;
  }
  .sign-in, .register-now {
    text-decoration: none;
  }
  .sign-in:hover, .register-now:hover {
    text-decoration: underline;
  }
  .sign-in-with-password {
    height: 14px;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #a5b1b6;
    margin-top: 28px;
  }
  .not-a-member {
    width: 195px;
    height: 14px;
    margin: 218px auto;
    font-family: IdealSans-Medium;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.39px;
    text-align: center;
    color: #000;
  }
  input {
    margin: 0px 0 10px 0px;
    padding: 15px;
    min-width: 270px;
  }
  label {
    margin-bottom: 0px;
    font-size:14px;
    font-style: italic;
  }
  button, .sign-in-with-password {
    cursor: pointer;
  }
</style>
